import useValidations from './useValidations'

export default function useValidateForm(form) {
	const { validate } = useValidations()

	const validateField = (fieldKey, showError = true) => {
		const { fields, validations } = form
		const validationArray = validations[fieldKey]
		if (validationArray && validationArray.length) {
			const fieldValud = fields[fieldKey]
			const { isValid, message } = validate(fieldValud, validationArray)
			if (!isValid && message && showError) {
				Object.assign(form.errors, { [fieldKey]: [message] })
			} else {
				Object.assign(form.errors, { [fieldKey]: [] })
			}
			return isValid
		}
		Object.assign(form.errors, { [fieldKey]: [] })
		return true
	}

	const validateForm = (showError = true) => {
		const { fields, validations } = form
		const isValid = Object.keys(fields)
			.map((key) => validateField(key, showError))
			.every((i) => i)
		return isValid
	}

	return {
		validateField,
		validateForm,
	}
}
